import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import { FaCalculator } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { scrollToSection } from '../utils/navigation';

const BMIFloat = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // Show the button after scrolling down 300px
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleBMIClick = () => {
    if (location.pathname === '/') {
      // If on home page, scroll to BMI calculator using the robust offset helper
      scrollToSection('bmi-calculator');
    } else {
      // If on other page, navigate to home page BMI calculator
      navigate('/#bmi-calculator');
    }
  };

  // On mobile, always show at bottom left above footer if visible
  const mobileClass = isMobile
    ? 'fixed left-4 bottom-32 z-40 bmi-float'
    : 'fixed bottom-24 right-4 z-40 md:bottom-32 md:right-6 bmi-float';

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          transition={{ duration: 0.3 }}
          className={mobileClass}
        >
          <motion.button
            onClick={handleBMIClick}
            className="group relative bg-gradient-to-r from-orange-500 to-orange-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaCalculator className="w-6 h-6" />
            {/* Tooltip */}
            <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-green-500 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
              BMI Calculator
                              <div className="absolute left-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-l-green-500"></div>
            </div>
            {/* Pulse animation */}
            <div className="absolute inset-0 rounded-full bg-orange-400 animate-ping opacity-20"></div>
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BMIFloat;